//
//
//
//
//
//

export default {
  name: 'DocumentWrapper'
}
